import { Routes } from '@angular/router';
import { IdentificationComponent } from './identification.component';
import { SteponeComponent } from '../stepone/stepone.component';
import { SteponeConfirmComponent } from '../stepone-confirm/stepone-confirm.component';
import { SteptwoComponent } from '../steptwo/steptwo.component';
import { StepthreeComponent } from '../stepthree/stepthree.component';
import { StepthreeConfirmComponent } from '../stepthree-confirm/stepthree-confirm.component';
import { StepAbortComponent } from '../step-abort/step-abort.component';
import { stepOneConfirmGuard, stepTwoGuard, stepThreeGuard, stepthreeConfirmGuard } from '../shared/identification.guard';

export const IDENTIFICATION_ROUTES: Routes = [
    { path: '', redirectTo: 'stepone', pathMatch: 'full' },
    { path: 'stepone', component: SteponeComponent },
    { path: 'stepone-confirm', component: SteponeConfirmComponent, canActivate: [stepOneConfirmGuard] },
    { path: 'steptwo', component: SteptwoComponent, canActivate: [stepTwoGuard] },
    { path: 'stepthree', component: StepthreeComponent, canActivate: [stepThreeGuard] },
    { path: 'stepthree-confirm', component: StepthreeConfirmComponent, canActivate: [stepthreeConfirmGuard] },
    { path: 'abort/:reasonCode', component: StepAbortComponent }
];
